import React from 'react'
import { Button, Col, Row } from 'reactstrap'
import './index.scss'

export default function DeleteContacts({ selectedRows, toggleModal, deleteAndLoadDataWithFilters, message }) {
  return (
    <>
      <span style={{ marginBottom: '10px' }}>{message || `Are you sure you want to delete following:`}</span>
      {selectedRows.map((customer) => (
        <Row key={customer.id}>
          <Col className='delete-row'>{customer.name}</Col>
        </Row>
      ))}
      <Row className='mt-4'>
        <Col className='d-flex justify-content-end'>
          <Button onClick={deleteAndLoadDataWithFilters} className={'btn btn-danger'} disabled={!selectedRows?.length}>
            Confirm
          </Button>
          <Button onClick={() => toggleModal('isDeleteModalToggle')} className={'btn btn-default ml-2'}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}
